import React, { useEffect } from 'react';

import { createStructuredSelector } from 'reselect';
import { selectModalFormTemplate, selectShowAddUnitOfMeasureModal } from '../../redux/modal/modal.reselect';
import { connect } from 'react-redux';
import ADD_UNIT_MEASURE_FORM_TEMPLATE from './add-unit-of-measure.template';
import { setModalTemplate, setModalType, setShowAddUnitOfMeasureModal } from '../../redux/modal/modal.actions';

import ModalContainer from '../modal/modal.container';

const AddUnitMeasure = ({
    showAddUnitOfMeasure,
    setModalTemplate,
    setModalType,
    formTemplate,
    setShowAddUnitOfMeasureModal
}) => {
    useEffect(() => {
        setModalType("ADD_UNIT_OF_MEASURE")
        setModalTemplate(ADD_UNIT_MEASURE_FORM_TEMPLATE);
    }, []);
    
    return (
        <div className="add_unit_measure">
            {
                Object.keys(formTemplate).length > 0 ?
                    <ModalContainer
                        showModal={showAddUnitOfMeasure}
                        setShowModal={setShowAddUnitOfMeasureModal}
                        size={"MEDIUM"}
                    /> 
                    : null
            }
        </div>
    )
}

const mapStateToProps = createStructuredSelector({
    showAddUnitOfMeasure: selectShowAddUnitOfMeasureModal,
    formTemplate: selectModalFormTemplate
})

const mapDispatchToProps = (disptach) => ({
    setShowAddUnitOfMeasureModal: () =>
        disptach(setShowAddUnitOfMeasureModal()),
    setModalTemplate: (formTemplate) =>
        disptach(setModalTemplate(formTemplate)),
    setModalType: (modalType) =>
        disptach(setModalType(modalType))
})

export default connect(mapStateToProps, mapDispatchToProps)(AddUnitMeasure);